import React from 'react';
import { Search, Handshake, BarChart3, CheckCircle2 } from 'lucide-react';
import { brokerageFeatures, investmentStats } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Search: Search,
  Handshake: Handshake,
  BarChart3: BarChart3,
  CheckCircle2: CheckCircle2
};

const Brokerage = () => {
  return (
    <section id="brokerage" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-sm font-semibold text-blue-600 mb-4 uppercase tracking-wide">Brokerage Services</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Expert Brokerage for Buyers and Sellers
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl">
            Whether you're buying your dream home or selling an investment property, our experienced brokers provide
            personalized service and market expertise to ensure successful transactions. We represent both
            buyers and sellers with integrity and professionalism.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image with Stat Overlay */}
          <div className="relative order-2 lg:order-1">
            <img
              src={investmentStats[1].image}
              alt="Luxury Residential Property"
              className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute bottom-8 right-8 bg-blue-600 text-white p-6 rounded-xl shadow-2xl">
              <div className="text-sm font-medium mb-2">{investmentStats[1].label}</div>
              <div className="text-5xl font-bold">{investmentStats[1].value}</div>
            </div>
          </div>

          {/* Features List */}
          <div className="space-y-6 order-1 lg:order-2">
            {brokerageFeatures.map((feature, index) => {
              const Icon = iconMap[feature.icon];
              return (
                <div
                  key={index}
                  className="border-l-4 border-blue-600 pl-6 py-4 hover:bg-white transition-all duration-300 rounded-r"
                >
                  <div className="flex items-start space-x-4">
                    <div className="bg-blue-50 p-3 rounded-full">
                      <Icon className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h4>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Call to Action Button */}
        <div className="text-center mt-12">
          <Button
            size="lg"
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-12 py-6 text-lg"
          >
            Get a Market Opinion
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Brokerage;